module.exports = __webpack_public_path__ + "static/media/eduma.dc5f3de9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/eduma.jpg
// module id = 419
// module chunks = 0